import {
  createContext, useEffect, useRef, useContext, useState,
} from 'react';
import {io} from 'socket.io-client';

import config from '@config/config';
import LocalStorageService from '@services/localStorage';
import {USER_ROLES} from '@utils/consts';
import {UserContext} from './User';

export const ChatContext = createContext({
  socket: null,
  openedChatRoomId: undefined,
  setOpenedChatRoomId: () => {},
  sharedChatList: null,
  setSharedChatList: () => {},
});

const ChatProvider = ({children}) => {
  const {profile: currentProfile} = useContext(UserContext);
  const [openedChatRoomId, setOpenedChatRoomId] = useState();
  // Published by whichever page already fetched the chat room list
  // (e.g. Messages.jsx), so ChatIcon's nav badge can reuse that live,
  // socket-updated list instead of maintaining its own separate fetch
  // that can drift out of sync with the one the page itself renders.
  const [sharedChatList, setSharedChatList] = useState(null);
  const socket = useRef();

  useEffect(() => {
    if (!currentProfile
      || (currentProfile.type !== USER_ROLES.STUDENT_ROLE
        && currentProfile.type !== USER_ROLES.COUNSELLOR_ROLE)
         || (socket.current && socket.current.connected)) {
      return undefined;
    }

    const accessToken = LocalStorageService.getAccessToken();

    if (!accessToken) {
      return undefined;
    }

    socket.current = io(config.chatRoomSocketDomain, {
      path: config.chatRoomSocketPath,
      query: {
        accessToken,
      },
    });

    return () => {
      if (socket?.current && socket.current.connected) {
        socket.current.disconnect();
      }
     };
  }, [currentProfile?.id]);

  const value = {
    socket,
    openedChatRoomId,
    setOpenedChatRoomId,
    sharedChatList,
    setSharedChatList,
  };

  return (
    <ChatContext.Provider value={{...value}}>{children}</ChatContext.Provider>
  );
};

export default ChatProvider;
